const BRAND_LOGO_BY_KEYWORD: Array<{ keywords: string[]; logoUrl: string }> = [
  { keywords: ['toyota', 'تويوتا'], logoUrl: '/assets/car_brands/toyota.svg' },
  { keywords: ['hyundai', 'هيونداي'], logoUrl: '/assets/car_brands/hyundai.svg' },
  { keywords: ['mercedes', 'mercedes-benz', 'مرسيدس'], logoUrl: '/assets/car_brands/mercedes.png' },
  { keywords: ['bmw', 'بي ام دبليو', 'بي إم دبليو'], logoUrl: '/assets/car_brands/bmw.svg' },
  { keywords: ['nissan', 'نيسان'], logoUrl: '/assets/car_brands/nissan.svg' },
  { keywords: ['kia', 'كيا'], logoUrl: '/assets/car_brands/kia.svg' },
  { keywords: ['honda', 'هوندا'], logoUrl: '/assets/car_brands/honda.svg' },
  { keywords: ['lexus', 'لكزس'], logoUrl: '/assets/car_brands/lexus.svg' },
  { keywords: ['audi', 'اودي', 'أودي'], logoUrl: '/assets/car_brands/audi.svg' },
  { keywords: ['volkswagen', 'vw', 'فولكس'], logoUrl: '/assets/car_brands/volkswagen.svg' },
  { keywords: ['ford', 'فورد'], logoUrl: '/assets/car_brands/ford.svg' },
  { keywords: ['chevrolet', 'شيفروليه', 'chevy'], logoUrl: '/assets/car_brands/chevrolet.svg' },
  { keywords: ['gmc'], logoUrl: '/assets/car_brands/gmc.png' },
  { keywords: ['mazda', 'مازدا'], logoUrl: '/assets/car_brands/mazda.svg' },
  { keywords: ['mitsubishi', 'ميتسوبيشي'], logoUrl: '/assets/car_brands/mitsubishi.svg' },
  { keywords: ['porsche', 'بورش', 'بورشه'], logoUrl: '/assets/car_brands/porsche.svg' },
  { keywords: ['tesla', 'تسلا'], logoUrl: '/assets/car_brands/tesla.svg' },
  { keywords: ['volvo', 'فولفو'], logoUrl: '/assets/car_brands/volvo.svg' },
  { keywords: ['subaru', 'سوبارو'], logoUrl: '/assets/car_brands/subaru.svg' },
  { keywords: ['suzuki', 'سوزوكي'], logoUrl: 'https://logo.clearbit.com/suzuki.co.jp' },
  { keywords: ['isuzu', 'ايسوزو', 'إيسوزو'], logoUrl: 'https://logo.clearbit.com/isuzu.co.jp' },
  { keywords: ['land rover', 'landrover', 'لاند روفر'], logoUrl: '/assets/car_brands/landrover.png' },
  { keywords: ['jeep', 'جيب'], logoUrl: '/assets/car_brands/jeep.svg' },
  { keywords: ['jaguar', 'جاكوار'], logoUrl: '/assets/car_brands/jaguar.png' },
  { keywords: ['infiniti', 'انفينيتي', 'إنفينيتي'], logoUrl: '/assets/car_brands/infiniti.svg' },
];

function normalizeText(value: string): string {
  return value.trim().toLowerCase();
}

export function getKnownCarBrandLogo(...candidates: Array<string | null | undefined>): string | null {
  const normalizedCandidates = candidates
    .filter((value): value is string => Boolean(value && typeof value === 'string'))
    .map(normalizeText)
    .filter(Boolean);

  if (normalizedCandidates.length === 0) return null;

  for (const brand of BRAND_LOGO_BY_KEYWORD) {
    if (brand.keywords.some((keyword) => normalizedCandidates.some((value) => value.includes(keyword)))) {
      return brand.logoUrl;
    }
  }

  return null;
}
